import apiBase from "../../api/axios";

export const startQuizSessionService = async () => {
  const response = await apiBase.post("v1/evaluacion/sesiones-evaluacion/");
  return response.data;
};

export const getNextQuestionService = async (sessionId) => {
  const response = await apiBase.get(
    `v1/evaluacion/sesiones-evaluacion/${sessionId}/siguiente_pregunta/`,
  );

  return response.data;
};

export const sendAnswerService = async (payload) => {
  const response = await apiBase.post(
    "v1/evaluacion/respuestas-evaluacion/",
    payload,
  );
  return response.data;
};

export const getQuizPhaseService = async () => {
  const response = await apiBase.get(
    "v1/evaluacion/sesiones-evaluacion/ver_fase/",
  );
  return response.data;
};

// Video tutorial de inicio del quiz (configuración GLOBAL)

export const getVideoTutorialInicioQuizService = async () => {
  const response = await apiBase.get("v1/video-tutorial-inicio-quiz/");
  return response.data;
};

export const putVideoTutorialInicioQuizFileService = async (file) => {
  const formData = new FormData();
  formData.append("video_tutorial", file);

  const response = await apiBase.put(
    "v1/video-tutorial-inicio-quiz/",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response.data;
};

export const putVideoTutorialInicioQuizUrlService = async (url) => {
  const response = await apiBase.put("v1/video-tutorial-inicio-quiz/", {
    video_tutorial_url: url,
  });
  return response.data;
};

